<template>
  <v-container>
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        md="6"
        lg="5"
      >
        <v-card class="pa-4">
          <v-card-title class="primary--text text--lighten-2 pb-0">
            {{ $t('Register') }}
          </v-card-title>
          <v-card-title class="primary--text pt-0">
            {{ $t('IQLS Laboratory Companion') }}
          </v-card-title>
          <v-card-text class="mt-8">
            <!--            <v-alert-->
            <!--              v-model="loginError"-->
            <!--              dense-->
            <!--              type="error"-->
            <!--              dismissible-->
            <!--            >-->
            <!--              {{ $t('The username or password is not correct.') }}-->
            <!--            </v-alert>-->

            <ValidationObserver
              ref="registerObserver"
              v-slot="{ validate, reset }"
            >
              <form @submit.prevent="submit">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <v-text-field
                    v-model="emailAddress"
                    :error-messages="errors"
                    :label="$t('E-mail')"
                    type="email"
                    autocomplate="username"
                    prepend-inner-icon="mdi-email"
                    required
                  />
                </ValidationProvider>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <v-text-field
                    v-model="firstName"
                    :error-messages="errors"
                    label="First Name"
                    required
                  />
                </ValidationProvider>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="Last Name"
                  rules="required"
                >
                  <v-text-field
                    v-model="lastName"
                    :error-messages="errors"
                    label="Last Name"
                    required
                  />
                </ValidationProvider>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="password"
                  rules="required|min:6"
                >
                  <v-text-field
                    v-model="password"
                    :error-messages="errors"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordShow ? 'text' : 'password'"
                    :label="$t('Password')"
                    autocomplete="current-password"
                    required
                    @click:append="passwordShow = !passwordShow"
                  />
                </ValidationProvider>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="Confirm Password"
                  rules="required|min:6|confirmed:password"
                >
                  <v-text-field
                    v-model="passwordConfirm"
                    :error-messages="errors"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordShow ? 'text' : 'password'"
                    :label="$t('Confirm password ')"
                    autocomplete="current-password"
                    required
                    @click:append="passwordShow = !passwordShow"
                  />
                </ValidationProvider>

                <v-btn
                  block
                  color="primary"
                  type="submit"
                  class="mr-4"
                >
                  {{ $t('Register') }}
                </v-btn>
              </form>

              <div class="d-flex mt-7">
                <v-btn
                  :to="{name: 'Login'}"
                  class="text-none mx-auto"
                  text
                >
                  {{ $t('Already have an account? Log In') }}
                </v-btn>
              </div>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import FormValidation from "../mixins/FormValidation";
    // import {mapActions} from 'vuex'

    export default {
        name: "Register",
        mixins: [FormValidation],
        data() {
            return {
                registerError: false,
                emailAddress: '',
                firstName: '',
                lastName: '',
                // birthDate: '',
                // gender: '',
                password: '',
                passwordConfirm: '',
                passwordShow: false,
            }
        },

        methods: {
            // ...mapActions([
            //     'login'
            // ]),

            async submit() {
                let valid = await this.$refs.registerObserver.validate();
                if (!valid) return;

                let registerData = {
                    emailAddress: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    password: this.password,
                };

                console.log(registerData);

                // TODO: add register route
                this.$router.push({name: "Login"})

                // this.login({loginData})
                //     .then(() => {
                //         let redirectUrl = this.$route?.query?.redirect;
                //         if (redirectUrl) {
                //             this.$router.push(redirectUrl)
                //         } else {
                //             this.$router.push({name: "Home"})
                //         }
                //     })
                //     .catch(() => {
                //         this.loginError = true
                //     })

            },
        }
    }
</script>

<style scoped>

</style>
